import * as React from "react";
const SvgFiBrandsPaypal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M22.928 11.414c-.907 4.416-3.974 5.948-7.884 5.948h-.594c-.501 0-.907.33-.97.781l-.062.24-.751 4.626-.032.21a.99.99 0 0 1-.97.781h-4.13c-.344-.03-.563-.33-.5-.631l.312-2.042H2.466a.61.61 0 0 1-.563-.721L5.156.901A1.12 1.12 0 0 1 6.251 0h7.76c2.69 0 4.787.54 5.913 1.802 1.064 1.171 1.376 2.433 1.064 4.295-.25-.12-.533-.24-.845-.33a9 9 0 0 0-1.22-.27 13.5 13.5 0 0 0-2.002-.15h-6.07c-.501 0-.907.33-.97.781l-1.313 7.87-.042.248a1.13 1.13 0 0 1 1.105-.908h2.285c4.475 0 7.979-1.742 8.98-6.789l.094-.45c.437.21.813.481 1.126.841 1 1.08 1.187 2.642.812 4.474"
    />
  </svg>
);
export default SvgFiBrandsPaypal;
